import React from 'react';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import overlayStyles from './OverlayHelpers.scss';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  isSectionBoundary?: boolean;
  __forceHoveredForStories?: boolean;
}

const HoverableWrapper = React.forwardRef<HTMLDivElement, Props>(
  ({ isSectionBoundary, className, __forceHoveredForStories, ...props }, ref) => {
    const newProps: React.HTMLAttributes<HTMLDivElement> = {
      ...props,
      className: classnames(
        overlayStyles['hoverable'],
        __forceHoveredForStories && overlayStyles['force-hovered'],
        className
      ),
    };
    return isSectionBoundary ? (
      <Section {...newProps} ref={ref} />
    ) : (
      <div {...newProps} ref={ref} />
    );
  }
);
HoverableWrapper.displayName = 'HoverableWrapper';

export default HoverableWrapper;
